import React, { useState } from "react";
import DocumentAccordion from "./documentAccordion";
import { formatNumberToCurrency } from "@utils/formatNumber";


const BillAccordion = ({ item }) => {

  const [toggle, setToggle] = useState(false)

  const Item = ({ item }) => {
    return <div key={item.client_name} className="accordion-item">
      <div className="accordion-item-body">
        <div>
          <div className="flex align-center gap-8">
            <button
              className={`accordion-toggle ${toggle ? "active" : ""}`}
              onClick={() => setToggle(!toggle)}
            ></button>
            <div className="grid">
              <span className="accordion-label">Cliente</span>
              <span className="accordion-title">{item?.client_name}</span>
            </div>
          </div>
        </div>
        <div className="margin-right-16">
          <span className="accordion-label">Valor Total</span>
          <span className="accordion-title">{formatNumberToCurrency(item?.total_value)}</span>
        </div>
      </div>
      {toggle && item?.items?.map((i, idx) => <div className="accordion-item-body margin-left-16">
        <div>
          <div className="flex align-center gap-8">
            <div className="grid">
              <span className="accordion-label">Id</span>
              <span className="accordion-title">{i?.id}</span>
            </div>
            <div className="grid margin-left-16">
              <span className="accordion-label">Data</span>
              <span className="accordion-title">{i?.payment_date.split('-').reverse().join('/')}</span>
            </div>
          </div>
        </div>
        <div className="margin-right-16">
          <span className="accordion-label">Valor</span>
          <span className="accordion-title">{formatNumberToCurrency(i?.value)}</span>
        </div>
      </div>)}
    </div>
  }

  return <Item item={item} />
}

export default BillAccordion;